import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Logo } from '@awaze/design-system.components.logo';
import { Stack } from '@awaze/design-system.components.stack';
import { ListItem } from '@awaze/design-system.components.list-item';
import { LocationSelector } from '@awaze/design-system.compositions.location-selector';
import styled, { css } from 'styled-components';
import { breakpoints } from '@awaze/design-system.utils.react';
import { Facebook, Instagram, Pinterest, YouTube, Linkedin, TwitterX, } from './icon';
const StyledSocialLink = styled.a `
  color: ${({ theme }) => theme.ColorWhiteOpacity100};

  @media (max-width: ${breakpoints[0]}px) {
    min-width: 40px;
  }
`;
const SocialIcon = ({ title }) => {
    switch (title) {
        case 'Twitter':
            return _jsx(TwitterX, {});
        case 'Facebook':
            return _jsx(Facebook, {});
        case 'Instagram':
            return _jsx(Instagram, {});
        case 'Pinterest':
            return _jsx(Pinterest, {});
        case 'YouTube':
            return _jsx(YouTube, {});
        case 'Linkedin':
            return _jsx(Linkedin, {});
    }
    return null;
};
const SocialLink = ({ href = '', displayText, rel, openInNew }) => (_jsx(ListItem, { children: _jsx(StyledSocialLink, { href: href, rel: rel ?? null, title: displayText, target: openInNew ? '_blank' : null, children: _jsx(SocialIcon, { title: displayText }) }) }));
const Layout = styled.div `
  display: flex;
  width: 100%;
  gap: 24px;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;

  @media (max-width: ${breakpoints[1]}px) {
    justify-content: space-between;
  }

  @media (max-width: ${breakpoints[0]}px) {
    ${(p) => !p.inlineLanguageSelector &&
    css `
        flex-direction: column;
        gap: 40px;
        > ul {
          width: 100%;
        }
        > button {
          align-self: flex-start;
        }
      `}
  }
`;
export const FooterSocialLinks = ({ socialLinks, styles, locationSelect, }) => {
    return (_jsxs(Stack, { direction: ['column-reverse', 'row', 'row'], justify: "space-between", align: ['start', 'center', 'center'], fullWidth: true, spacing: [44, 0, 0], children: [_jsx(Stack, { direction: "row", align: "center", spacing: 24, wrap: ['wrap', 'nowrap', 'nowrap'], children: _jsx(Logo, { brand: "partofawaze" }) }), _jsxs(Layout, { inlineLanguageSelector: socialLinks.length < 3, children: [locationSelect && _jsx(LocationSelector, { ...locationSelect }), _jsx(Stack, { as: "ul", direction: "row", align: "flex-end", spacing: 24, justify: styles?.justify ?? ['space-around', 'flex-end', 'flex-end'], children: socialLinks.map(({ displayText, href, openInNew, rel }) => (_jsx(SocialLink, { displayText: displayText, href: href, openInNew: openInNew, rel: rel }, displayText))) })] })] }));
};
//# sourceMappingURL=footer-social-links.js.map